"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var componentName = 'wok-dialog';
exports.default = composition_api_1.defineComponent({
    name: componentName,
    props: {
        kind: {
            type: String,
            default: 'alert',
            validator: function (v) { return v == '' || /(alert|simple|confirmation)/.test(v); }
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    setup: function (props, context) {
        var wrapperClasses = composition_api_1.computed(function () {
            var _a;
            return _a = {
                    'wok--dialog__wrapper': true,
                    'wok--dialog--is-loading': props.isLoading
                },
                _a["wok--dialog--" + props.kind] = props.kind,
                _a;
        });
        var onRequestHideDialog = function () {
            if (!props.isLoading) {
                context.emit('hide-dialog');
            }
        };
        return {
            wrapperClasses: wrapperClasses,
            onRequestHideDialog: onRequestHideDialog
        };
    }
});
